export function isUploadFileSizeExceeded(
  file: File,
  maxSizeInBytes: number
): boolean {
  return file.size > maxSizeInBytes;
}
